import React from 'react';
import { Redirect } from 'react-router-dom';

// @source
import { Account as API } from '../server';
import { account as constant } from '../constants';
import {
  Private,
  Protected,
  Public,
  Mobile,
} from './store';
import { Router } from '../modules';
import { User } from '../tools';

export default () => {
  Router.apply(Private, (props, View) => {
    const account = User.getUserInfo();
    if (account) {
      if (account.Token) {
        API.verifyToken();
        const isMobile = window.outerWidth < 768;
        if (isMobile) {
          account.Type = constant.USER;
        }

        if (account.Type === constant.USER) {
          const permissions = ['/excel', '/trend'];
          if (permissions.includes(props.match.path)) {
            return <View account={account} {...props} />;
          }
          return <Redirect to="/excel" />;
        }
        return <View account={account} {...props} />;
      }
      return <Redirect to="/account/login?redirect=token" />;
    }
    return <Redirect to="/account/login" />;
  });

  Router.apply(Protected, () => (
    User.getToken() ? <Redirect to="/home" /> : false
  ));

  // View pages accessible from the mobile app
  Router.apply(Mobile);

  // Publicly accessible view pages
  Router.apply(Public);

  // Revert all available redirects
  return Router.store;
};
